import { Handshake } from 'lucide-react';
import { useT } from '../../i18n';
import { SetupCard } from '../ui';

/**
 * THE «SAMARBEID» ENTRY IN THE ORGANIZATION'S SETTINGS (slice 4a, 2026-10-20).
 *
 * Its own component for the reason `AccessSettingsCard` is: the settings view
 * is a legacy surface whose render-contract tests mount it without a locale
 * provider, and this text is a catalog key. Rendered only for somebody whose
 * capability union here holds `organization.links.manage` — Eier by default —
 * so nobody else sees a door the server would refuse.
 */
export function LinksSettingsCard({ onOpen }: { onOpen: () => void }) {
  const t = useT();
  return (
    <SetupCard label={t('clubSettings.links.title')}>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <p className="text-sm text-ink-2">{t('clubSettings.links.lead')}</p>
        <button
          type="button"
          onClick={onOpen}
          className="btn-outline text-xs flex-shrink-0 inline-flex items-center gap-1.5"
          data-testid="club-settings-open-links"
        >
          <Handshake size={12} /> {t('clubSettings.links.open')}
        </button>
      </div>
    </SetupCard>
  );
}
